import { HStack } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { IconName } from '@televet/kibble-ui/build/components/Icon';
import { partial } from 'lodash-es';
import React, { useCallback } from 'react';
import { BoardFilterView, UpdateUserBoardFilterSettingsMutationFn } from 'shared/types/graphql';
import { capitalize } from 'shared/utils';
import { useAppSelector } from 'state/hooks';

const boardTypeIconMap: Record<BoardFilterView, IconName> = {
  [BoardFilterView.Conversations]: 'chatBubble',
  [BoardFilterView.Appointments]: 'calendarDate',
  [BoardFilterView.Automations]: 'robot',
};

const boardFilterViews: BoardFilterView[] = [
  BoardFilterView.Conversations,
  BoardFilterView.Appointments,
  BoardFilterView.Automations,
];

interface ViewToggleProps {
  updateBoardSettings: UpdateUserBoardFilterSettingsMutationFn;
}

const ViewToggle = ({ updateBoardSettings }: ViewToggleProps): JSX.Element => {
  const { clinicUserId, currentClinicId, boardSettings } = useAppSelector((state) => state.board);

  const handleUpdateBoardView = useCallback(
    async (boardType: BoardFilterView) => {
      await updateBoardSettings({
        variables: {
          where: {
            userId: clinicUserId || '',
            clinicId: currentClinicId || '',
          },
          data: {
            currentView: boardType,
          },
        },
      });
    },
    [clinicUserId, currentClinicId, updateBoardSettings],
  );

  return (
    <HStack justifySelf="flex-end">
      {boardFilterViews.map((boardType, index): JSX.Element => {
        return (
          <Button
            id={`board-filter-button-${boardType}`}
            key={`${boardType}-${index}`}
            variant={boardSettings?.currentView === boardType ? 'ghost' : 'secondarySubtle'}
            size="xs"
            iconName={boardTypeIconMap[boardType]}
            isActive={boardSettings?.currentView === boardType}
            onClick={partial(handleUpdateBoardView, boardType)}
          >
            {capitalize(boardType)}
          </Button>
        );
      })}
    </HStack>
  );
};

export default ViewToggle;
